module.exports = __webpack_public_path__ + "img/jcnr.10d5f632.png";